import { BillwerkChargeRequest } from 'src/app/model/interfaces/billwerk-charge-recurring';
import { ApiPostRequest } from '../api-post-request';

export class ChargeRequest extends ApiPostRequest
{
    public constructor(payload: BillwerkChargeRequest, webapiBasepath: string)
    {
        super('billwerk/charge',
        null,
        null,
        payload,
        webapiBasepath
    );
    }
}
